import { reactive, ref } from 'vue'
import axios from '../plugins/axios'
import { user } from '@/core/auth'

export const listFilterDataOrder = ref([])
export const orders = ref([])
export const offlineOrders = ref([])
export const loading = reactive({
  filterOrder: false,
  order: false
})

export const getListFilterDataForOrder = async (payload) => {
  try {
    loading.filterOrder = true
    const { data } = await axios.get('app/list_filter_user_all', {
      params: payload
    }, {
      headers: {
        id_pendaftar: user.value.id,
        token_api: user.value.token_api
      }
    })

    if (data.success) {
      listFilterDataOrder.value = data.data
    }
  } catch (error) {
    console.error('error get list filter data order = ', error)
    throw error
  } finally {
    loading.filterOrder = false
  }
}

export const getOrders = async (payload) => {
  try {
    loading.order = true

    const { data } = await axios.get('app/transaksi_online', {
      params: payload
    })

    orders.value = data.data
  } catch (error) {
    console.error('Error dari order getOrders', error)
    // Reset jadi kosong kalau error
    orders.value = []
    throw error
  } finally {
    loading.order = false
  }
}

export const getOfflineOrders = async (payload) => {
  try {
    loading.order = true

    const { data } = await axios.get('app/data_daftar_offline_v2', {
      params: payload
    })

    offlineOrders.value = data.data
  } catch (error) {
    console.error('Error dari order getOfflineOrders', error)
    // Reset jadi kosong kalau error
    offlineOrders.value = []
    throw error
  } finally {
    loading.order = false
  }
}
